module.exports = __webpack_public_path__ + "img/jeonpo_gallery1.d1785fad.jpg";